import type { DesignerNode } from "../types/index.ts";

export type MediaType = "audio" | "image" | "video" | "model";

export const allMediaTypes: MediaType[] = ["audio", "image", "video", "model"];

export const mediaTypeToTypeId: Record<MediaType, string> = {
  audio: "audio",
  image: "image",
  video: "video",
  model: "model",
};

export const mapMediaTypeToNodeTypeId = (mediaType: MediaType): string => {
  const typeId = mediaTypeToTypeId[mediaType];

  if (!typeId) {
    throw new Error(`Media type not recognized: "${mediaType}".`);
  }

  return typeId;
};

export const mapContentTypeToMediaType = (contentType: string) => {
  const type = contentType.replace(/\/.*$/, "") as MediaType;
  const mediaType = allMediaTypes.find((t) => t === type);

  if (!mediaType) {
    throw new Error(`Unrecognized media content type: "${contentType}".`);
  }

  return mediaType;
};

export const measureImage = (file: File): Promise<{ width: number; height: number }> =>
  new Promise((resolve) => {
    const image = new Image();
    image.src = URL.createObjectURL(file);
    image.onload = function () {
      URL.revokeObjectURL(image.src);
      // @ts-ignore
      resolve({ width: this.width, height: this.height });
    };
  });

export const augmentMediaNodeConfig = async (file: File, mediaNode: DesignerNode): Promise<DesignerNode> => {
  if (mediaNode.typeId !== "image") return mediaNode;

  const { width: naturalWidth, height: naturalHeight } = await measureImage(file);
  return {
    ...mediaNode,
    config: {
      ...mediaNode.config,
      naturalHeight,
      naturalWidth,
    },
  };
};
